import React, { useEffect, useState, useRef } from "react";
import { GetSingleSetParam, isWebSiteClose } from "src/Basic/CommonService";
import { getPIContent } from "src/HomePage/PersonalInformation.service";
import { showGlobalMessageBox } from "src/Route/RootMiddleware";

const ConfirmPersonalInformation = ({ returnLogin, goRegister }) => {
  const [PersonalInformationContent, setPersonalInformationContent] = useState(); //定義個資聲明的內容
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false); //滾動條是否滑動到底部
  const contentRef = useRef(null); //監控DOM

  // 頁面初始化
  useEffect(() => {
    checkWebSiteClose();
  }, []);

  /**
   * 檢查網站是否關閉，若關閉則顯示訊息並返回登入頁面，若未關閉則取得個資聲明內容
   * 此頁面為未登入前流程，不需要判斷特權帳號，直接用 isWebSiteClose 即可。
   */
  const checkWebSiteClose = async () => {
    if (await isWebSiteClose()) {
      showGlobalMessageBox("系統維護中，暫不開放", () => { returnLogin() });
    }
    else {
      getPersonalInformationContent('Register', 'RegisterMessage', 'A');

    }
  }
  // 取得個資聲明內容
  const getPersonalInformationContent = async (path, setItem, setType) => {
    const result = await getPIContent(path, setItem, setType);
    if (result.SET_VALUE) {
      setPersonalInformationContent(result.SET_VALUE);
    }
  };


  //當滾動條到底部，同意按鈕變成可以點選
  const handleScroll = () => {
    const element = contentRef.current;
    //元素的總高度（scrollHeight）-已滾動的距離（scrollTop）=元素的視口高度（clientHeight）
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      setIsScrolledToBottom(true);
    }
  };


  // 頁面內容
  return (
    <div className="login_content_right_box_width">
      <div className="personal_Information_box">
        <form style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <div className="login_box_heade personal_Information_item">
            <div className="login_box_headline me-auto">註冊</div>
            <div className="login_box_btn" onClick={() => returnLogin()}>前往登入</div>
          </div>
          <div className="personal_Information_contentitem" ref={contentRef} onScroll={handleScroll}>
            <div className="personal_Information_item">請先同意以下個資聲明</div>
            <hr />
            <div className="personal_Information_item">{PersonalInformationContent}</div>
          </div>
          <button className="personal_Information_item blue_common_button"
            // disabled={!isScrolledToBottom}
            onClick={() => goRegister()}
          >同意</button>
        </form>
      </div>
    </div >
  );
};

export default ConfirmPersonalInformation;
